import { useMediaQuery } from "@chakra-ui/react";
import "./App.css"
import React, { useState,useEffect } from 'react';
import {
  MDBContainer,
  MDBCollapse,
  MDBNavbar,
  MDBNavbarToggler,
  MDBIcon,
  MDBBtn,
} from 'mdb-react-ui-kit';



export default function Navbar() {



  const [showAnimated, setShowAnimated] = useState(false);

  return (
    
    <>
      <section >
        <MDBNavbar >
          <MDBContainer fluid>
            <MDBNavbarToggler
              type='button'
              className='first-button'
              data-target='#navbarToggleExternalContent'
              aria-controls='navbarToggleExternalContent'
              aria-expanded='false'
              aria-label='Toggle navigation'
              onClick={() => setShowAnimated(!showAnimated)}
            >
              <div className={`animated-icon1 ${showAnimated && 'open'}`}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </MDBNavbarToggler>
          </MDBContainer>
        </MDBNavbar>

        <MDBCollapse open={showAnimated}>
          <div className='bg-light shadow-3 p-4'>
            <MDBBtn block className='border-bottom m-0' color='link'>
              Scegli una foto
            </MDBBtn>
            <MDBBtn block className='border-bottom m-0' color='link'>
              Pernottamento
            </MDBBtn>
            <MDBBtn block className='border-bottom m-0' color='link'>
              Esci
            </MDBBtn>
          </div>
        </MDBCollapse>
      </section>

      

      
    </>
  );
}
